<template>
  <div>  
    start:{{ resultaat.prognose.start }}
    eind:{{ resultaat.prognose.eind }}
    groepen:{{ resultaat.prognose.groepen }}
    totalen:{{ resultaat.prognose.totalen }}
    <b-table 
      :items="resultaat.prognose.rijen" 
      :fields="['titel','acties','resultaat']" 
      responsive
    />
  </div>
</template>

<script>

  import { prognoseMixin } from "@/mixins/prognoseMixin";

  export default {
    name: "ResultaatMatrix",
    mixins: [ prognoseMixin ],
    
    computed: {
      resultaat:  function() {
        return {
          prognose: this.getPrognoseResultaat(this.rows)
        };
      } 
    },

  };

</script>